// extracted by mini-css-extract-plugin
export var bannerImage = "GiftLandingPage-module__bannerImage___HUrWm";